export default __webpack_public_path__ + "static/media/filter.8c8ee1f2.svg";